// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2PfE_","empty":"ModalGraph_empty__3KQP2"};